import * as React from "react";
import { useContext, useMemo, useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import { exportTariffStatement } from "@/utils";
import { useLang, useTextDomainContext } from "@/app/providers";
import { TfiImport } from "react-icons/tfi";
import { arrayOf, object, string } from "prop-types";

export const ExportTariffStatementDropdown = (props: any) => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const locale = useLang();
  const [anchorEl, setAnchorEl] = useState<any>(null);
  const open = Boolean(anchorEl);

  const data = useMemo(() => {
    return props.data ?? [];
  }, [props.data]);

  const fileName = useMemo(() => {
    return props.fileName ?? "export";
  }, [props.fileName]);

  // const [data, setData] = useState(typeof props.data === "undefined" ? [] : props.data);
  // const [fileName, setFileName] = useState(typeof props.fileName === "undefined" ? "export" : props.fileName);

  // useEffect(() => {
  //   if (typeof props.data !== "undefined") {
  //     setData(props.data);
  //   }
  // }, [props.data]);

  // useEffect(() => {
  //   if (typeof props.fileName !== "undefined") {
  //     setFileName(props.fileName);
  //   }
  // }, [props.fileName]);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleExportToExcel = () => {
    exportTariffStatement(data, `${fileName}.xlsx`, gettext, locale).then();
    handleClose();
  };

  // const handleExportToCsv = () => {
  //   ExportToCsv(data, `${fileName}.csv`);
  //   handleClose();
  // };

  // const handleExportToPdf = () => {
  //   ExportToPdf(data, `${fileName}.pdf`);
  //   handleClose();
  // };

  return (
    <>
      <Button
        id="fade-button"
        aria-controls={open ? "fade-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        endIcon={<TfiImport size={14} />}
        disabled={!data?.length}
        sx={{
          ml: 1,
          color: "grey.600",
          fontWeight: 400,
        }}
      >
        {gettext("export")}
      </Button>
      <Menu
        id="fade-menu"
        slotProps={{
          list: {
            "aria-labelledby": "fade-button",
          },
        }}
        slots={{
          transition: Fade,
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem
          onClick={handleExportToExcel}
          sx={{
            fontSize: "0.875rem",
            color: "grey.600",
            fontWeight: 300,
          }}
        >
          {gettext("export to Excel")}
        </MenuItem>
        {/*<MenuItem*/}
        {/*  onClick={handleExportToPdf}*/}
        {/*  sx={{*/}
        {/*    fontSize: "0.875rem",*/}
        {/*    color: "grey.600",*/}
        {/*    fontWeight: 300*/}
        {/*  }}*/}
        {/*>*/}
        {/*  {gettext("export to PDF")}*/}
        {/*</MenuItem>*/}
      </Menu>
    </>
  );
};

ExportTariffStatementDropdown.propTypes = {
  data: arrayOf(object),
  fileName: string,
};
